import { RARITIES } from '../data/items.js';
import { AURA_SLOTS } from './inventory.js';
/** Rarity of every equipment slot worn above common. */
export function pieceRaritiesOf(equipped, templateOf) {
    const rarities = {};
    for (const slot of AURA_SLOTS) {
        const instance = equipped[slot];
        if (instance === undefined)
            continue;
        const rarity = templateOf(instance.templateId)?.rarity;
        if (rarity !== undefined && rarity !== 'common')
            rarities[slot] = rarity;
    }
    return rarities;
}
/** Two bits a slot, in `AURA_SLOTS` order: one small number in the synchronised state. */
export function packRarities(rarities) {
    return AURA_SLOTS.reduce((packed, slot, index) => packed | (RARITIES.indexOf(rarities[slot] ?? 'common') << (2 * index)), 0);
}
export function unpackRarities(packed) {
    const rarities = {};
    AURA_SLOTS.forEach((slot, index) => {
        const rarity = RARITIES[(packed >> (2 * index)) & 3];
        if (rarity !== undefined && rarity !== 'common')
            rarities[slot] = rarity;
    });
    return rarities;
}
//# sourceMappingURL=piece-rarity.js.map